import { useContext } from 'react'

import { CommandLine } from 'providers/CommandLineWrapper'

export const useCommandLine = () => useContext(CommandLine)
